import { Td, Tr, TableCellProps } from '@chakra-ui/react';

const QuoteColumn = (props: TableCellProps) => <Td textAlign="center" p={3} {...props} />;

const QuoteRow = ({
  partNumber,
  column1,
  column2,
  version,
}: {
  partNumber?: string;
  column1?: string;
  column2?: string;
  version?: number;
}) => (
  <Tr
    key={partNumber}
    sx={{
      h: 25,
      fontSize: 'sm',
      px: 6,
      bgColor: version === 1 ? 'white' : 'base2Colour.500',
    }}
  >
    <QuoteColumn>{column1}</QuoteColumn>
    <QuoteColumn>{column2}</QuoteColumn>
  </Tr>
);

export default QuoteRow;
